<template>
  <div class="modal fade" id="edit-delivery-date-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-sm" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')">&times;</button>
          <h4 class="modal-title">納品予定日の変更</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="control-label label-normal">納品予定日</label>
            <date-picker
              ref="datepicker"
              v-model="selectedDate"
              placeholder=""
              format="YYYY/MM/DD"
              value-type="format"
              :lang="lang"
              :not-before="tomorrow"
              :append-to-body="false"
              :popup-style="{ position: 'static', boxShadow: 'none', border: 'none', marginTop: 0 }"
              @input="onDateInput"
            ></date-picker>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" :disabled="!selectedDate" @click="handleConfirm">OK</button>
          <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  components: {
    DatePicker
  },
  props: {
    delivery: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedDate: this.delivery.deliveryDate || '',
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      }
    }
  },
  computed: {
    tomorrow () {
      const d = new Date()
      d.setDate(d.getDate() + 1)
      d.setHours(0, 0, 0, 0)
      return d
    }
  },
  methods: {
    onDateInput (val) {
      this.selectedDate = val
      this.$nextTick(() => {
        this.$refs.datepicker.showPopup()
      })
    },
    handleConfirm () {
      this.$emit('confirm', this.delivery.deliveryNo, this.selectedDate)
    }
  },
  mounted () {
    $('#edit-delivery-date-modal').modal('show')
    this.$nextTick(() => {
      this.$refs.datepicker.showPopup()
    })
  },
  beforeDestroy () {
    this.$emit('close')
  }
}
</script>

<style scoped>
.modal-title {
  color: #fff;
}
.mx-datepicker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/ModalEditDeliveryDate.vue